/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Help_UntranslatedInputs */

const en_help_untranslated = /** @type {(inputs: Help_UntranslatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This article is not translated yet, so it is shown in its original language (${i?.language}).`)
};

const pl_help_untranslated = /** @type {(inputs: Help_UntranslatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ten artykuł nie ma jeszcze polskiej wersji, więc pokazujemy oryginał (${i?.language}).`)
};

/**
* | output |
* | --- |
* | "This article is not translated yet, so it is shown in its original language ({language})." |
*
* @param {Help_UntranslatedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_untranslated = /** @type {((inputs: Help_UntranslatedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_UntranslatedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_untranslated(inputs)
	return en_help_untranslated(inputs)
});